import { useEffect } from 'react';
import { EventType } from '@azure/msal-browser';
import { useMsal } from '@azure/msal-react';
import { isAuthenticationResult } from '@/lib/msal';

export function useMsalLoginSuccessCallback(
  onLoginSuccess: (state?: string) => void,
) {
  const { instance } = useMsal();

  useEffect(() => {
    const callbackId = instance.addEventCallback((event) => {
      if (
        event.eventType === EventType.LOGIN_SUCCESS &&
        isAuthenticationResult(event.payload)
      ) {
        onLoginSuccess(event.payload.state);
      }
    });

    return () => {
      if (callbackId) {
        instance.removeEventCallback(callbackId);
      }
    };
  }, [instance, onLoginSuccess]);
}
